











































































import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';

export default {
    name: 'PasswordlessStep',
    components: {
        CoButton,
        CoFormGroup,
        CoInput,
        CoText,
    },
    props: {
        allowPassword: {
            type: Boolean,
            default: false,
        },
        email: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        passwordlessStarted: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cooldownIntervalId: null,
            otp: '',
            resendCooldown: 0,
        };
    },
    computed: {
        resendCodeLabel() {
            if (!this.resendCooldownActive) {
                return this.$t('messages.auth.resendCode');
            }

            return this.$t('messages.resendconfirmationcodein', {
                countdown: `${this.resendCooldown}s`,
            });
        },
        resendCooldownActive() {
            return this.resendCooldown > 0;
        },
    },
    watch: {
        passwordlessStarted(value) {
            if (!value) {
                this.stopResendCooldown();
                return;
            }

            // Start the cooldown whenever a passwordless code becomes active in the UI.
            this.startResendCooldown();
        },
    },
    mounted() {
        // Password-enabled users enter this component after their OTP request has completed.
        if (this.passwordlessStarted) {
            this.startResendCooldown();
        }
    },
    beforeDestroy() {
        this.stopResendCooldown();
    },
    methods: {
        resendCode() {
            if (this.loading || this.resendCooldownActive) {
                return;
            }

            this.startResendCooldown();
            this.$emit('start');
        },
        startResendCooldown() {
            this.stopResendCooldown();
            this.resendCooldown = 60;
            this.cooldownIntervalId = window.setInterval(() => {
                if (this.resendCooldown <= 1) {
                    this.stopResendCooldown();
                    return;
                }

                this.resendCooldown -= 1;
            }, 1000);
        },
        stopResendCooldown() {
            if (this.cooldownIntervalId) {
                clearInterval(this.cooldownIntervalId);
                this.cooldownIntervalId = null;
            }

            this.resendCooldown = 0;
        },
        submit() {
            this.$emit('verify', this.otp);
        },
    },
};
